<template>
  <div class="file-attachment">
    <a :href="file.url" @click="previewFile($event, file)" :target="target"><i :class="['fas', iconForUserFile(file.mimeType)]"></i> &nbsp;{{file.name}}</a>
  </div>
</template>

<style lang="scss" scoped>
.file-attachment {
  display: inline-block;
  margin: 3px 3px 3px 0px;
  padding: 3px;
  border-radius: 4px;
  border: 1px solid #e7eaec;
  font-size: 11px;
}
.file-attachment i {
  font-size: 12px;
}
.file-attachment a {
  color: #676a6c;
}
.file-attachment a:hover {
  color: #337ab7;
  text-decoration: underline;
}
</style>

<script>
import UserFileMixin from '@/mixins/userFile'
import DocumentPreviewDialog from '@/components/dialog/documentPreviewDialog'

export default {
  name: 'FileAttachment',
  mixins: [UserFileMixin],
  props: {
    file: Object,
    isTempUpload: Boolean,
    newTab: Boolean
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  },
  methods: {
    previewFile(ev, file) {
      if(!this.newTab)
        ev.preventDefault()
      else
        return

      this.displayModal(DocumentPreviewDialog, {
        uploadFile: this.isTempUpload ? this.file : null,
        documentList: this.isTempUpload ? [] : [this.file],
      })
      .then(() => { })
    },
  }
}
</script>